import React, { useContext, useState } from "react";
import { AlenSchedule } from "src/interfaces/IProgram";
import { createOrUpdateAlenSchedule } from "src/services/alen/useAlenSchedules";
import { AuthContext } from "src/contexts/AuthContext";
import { Stack } from "@mui/material";
import ScheduleItem from "./AlenScheduleItem";
import { useAlenSchedulingContext } from "./AlenSchedulingContext";
import ScheduleTargetSelectionDialog from "./SchduleTargetSelectionDialog";
import { ScheduleDto, ScheduleTargetSelection } from "./types";
import NewScheduleDetailsDialog from "./NewSchedulingDetailsDialog";

export default function AlenScheduleList({
  schedules,
  onStatusChange,
}: {
  schedules: AlenSchedule[];
  onStatusChange: () => void;
}) {
  const { setNewScheduling, setScheduleTarget } = useAlenSchedulingContext();
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [isTargetDialogOpen, setIsTargetDialogOpen] = useState(false);
  const handleUpdate = (schedule: AlenSchedule) => {
    setNewScheduling((prev) => ({ ...prev, ...schedule }));
    setIsTargetDialogOpen(true);
  };
  const handleNext = (target: ScheduleTargetSelection) => {
    setScheduleTarget(target);
    setIsTargetDialogOpen(false);
    setIsDetailDialogOpen(true);
  };

  const handleBack = () => {
    setIsTargetDialogOpen(true);
    setIsDetailDialogOpen(false);
  };

  const { user } = useContext(AuthContext);

  const handleSave = async (schedule: ScheduleDto) => {
    setIsTargetDialogOpen(false);
    if (!user?.alen) {
      return;
    }
    await createOrUpdateAlenSchedule(user.alen, schedule);
    onStatusChange();
    setIsDetailDialogOpen(false);
  };

  return (
    <Stack direction="row" gap={2} flexWrap="wrap">
      {schedules.map((schedule) => (
        <ScheduleItem
          onClick={() => handleUpdate(schedule)}
          onStatusChange={onStatusChange}
          key={schedule.deviceSchedulerId}
          schedule={schedule}
        />
      ))}
      <ScheduleTargetSelectionDialog
        open={isTargetDialogOpen}
        onClose={() => setIsTargetDialogOpen(false)}
        onNext={handleNext}
      />
      <NewScheduleDetailsDialog
        onClose={() => setIsDetailDialogOpen(false)}
        open={isDetailDialogOpen}
        onBack={handleBack}
        onSave={handleSave}
      />
    </Stack>
  );
}
